﻿import ko from 'knockout';
import $ from 'jquery';
import { IBinder, IBehaviorBinding } from "./ibinder"
import { JsonBuilder } from "../jsonbuilder";

export class ToJSONBinder implements IBinder {
  public getElements(root: JQuery): JQuery {
    if (root.is("table"))
      return root;
    return root.find("table");
  }

  public getBinding(element: JQuery): IBehaviorBinding {

    return {
      bindingName: "attr",
      bindTo: "{'data-et-data' : JsonBuilder.toJSON($data)}",
      behavior: null
    }
  }
}
